module.exports = __webpack_public_path__ + "img/chrysantheme.2eeb0559.jpg";